import { render, staticRenderFns } from "./VersionTable.vue?vue&type=template&id=1131d353&scoped=true"
import script from "./VersionTable.vue?vue&type=script&lang=js"
export * from "./VersionTable.vue?vue&type=script&lang=js"
import style0 from "./VersionTable.vue?vue&type=style&index=0&id=1131d353&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1131d353",
  null
  
)

export default component.exports